export const SIDE_PANEL_MAX_IMAGE_LIMIT = 4;

export const SHARE_OPTIONS = [
  {
    id: 1,
    portal: 'Copy Link',
    logo: 'https://cdn.dotpe.in/kiranaStatic/custom_website/link_1.svg',
  },
  {
    id: 2,
    portal: 'Facebook',
    logo: 'https://cdn.dotpe.in/kiranaStatic/custom_website/facebook_1.svg',
  },
  {
    id: 3,
    portal: 'Whatsapp',
    logo: 'https://cdn.dotpe.in/kiranaStatic/custom_website/whatsapp_1.svg',
  },
  {
    id: 4,
    portal: 'Twitter',
    logo: 'https://cdn.dotpe.in/kiranaStatic/custom_website/twitter_1.svg',
  },
  {
    id: 5,
    portal: 'Telegram',
    logo: 'https://cdn.dotpe.in/kiranaStatic/custom_website/telegram_1.svg',
  },
];
